import { useContext, useMemo, useEffect } from 'react';
import { OnboardingContext } from 'providers/onboarding-provider';
import { ClientLogin, ClientSignup, ResetPassword } from './components';
import Images from 'assets/Images';
import { useLocation } from 'react-router-dom';
import './style.scss';

const ClientOnboarding = () => {
	const { signupToggler, setResetPwdStatus, setSignupToggler } = useContext(OnboardingContext);
	const search = useLocation().search;

	const initLogin = () => {
		const obj = {};
		const keys = ['username', 'token', 'id', 'mode'];
		keys.forEach(el => (obj[el] = new URLSearchParams(search).get(el)));
		if (obj?.mode === 'RESET_PWD' && obj?.username && obj?.token && obj?.id) {
			setResetPwdStatus(obj);
			setSignupToggler('RESET_PWD');
		}
	};

	const formContent = useMemo(() => {
		const obj = {
			SIGNUP: () => <ClientSignup />,
			SIGNIN: () => <ClientLogin />,
			RESET_PWD: () => <ResetPassword />,
			DEFAULT: () => null
		};
		return (obj[signupToggler] || obj['DEFAULT'])();
	}, [signupToggler]);

	useEffect(() => {
		initLogin();
	}, []);

	return (
		<>
			<div className='client-onboard'>
				<div className='client-onboard__logo'>
					<img src={Images.loginLogo} alt='App logo' />
					<h1>{process.env.REACT_APP_NAME}</h1>
				</div>
				<div className='client-onboard__container'>{formContent}</div>
			</div>
		</>
	);
};

export default ClientOnboarding;
